import { doctorChartTooltipHandler } from "./doctorChartTooltip";

const useDoctorChart = (data) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    elements: {
      line: {
        tension: 0.4,
      },
    },
    plugins: {
      tooltip: {
        enabled: false,
        position: "nearest",
        external: doctorChartTooltipHandler,
      },
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Signed Report",
          font: {
            size: 9,
          },
        },
      },
    },
  };

  const chartData = {
    labels: data?.labels,
    datasets: [
      {
        label: "Total",
        data: data?.data,
        borderColor: "#94BA33",
        backgroundColor: "#94BA33",
        barThickness: 20,
      },
    ],
  };

  return { options, chartData };
};

export default useDoctorChart;
